import { useMemo } from "react";
import { shallowEqual } from "react-redux";
import { conversationTypeList } from "../constants";
import { useChatsUIContext } from "../context/ChatsContext";
import { ConversationTypeEnum } from "../types/enums";
import { useChatSelector } from "./reduxHook";

const useChatUtils = () => {
  const selectedChat = useChatSelector(
    (state) => state.chats.selectedChat,
    shallowEqual
  );

  const chatsContext = useChatsUIContext();
  const chatsUIProps = useMemo(() => {
    return {
      navigatePage: chatsContext?.navigatePage,
    };
  }, [chatsContext?.navigatePage]);

  const muteButtonShow: boolean = useMemo(() => {
    return !conversationTypeList.includes(chatsContext?.navigatePage?.current!);
  }, [chatsUIProps?.navigatePage]);

  const deleteLeaveButtonsShow: boolean = useMemo(() => {
    return (
      !!selectedChat?._id &&
      conversationTypeList.includes(chatsContext?.navigatePage?.current!)
    );
  }, [selectedChat, chatsContext?.navigatePage]);

  const checkRole: boolean = useMemo(() => {
    return !!(
      selectedChat?.membership?.role ||
      selectedChat?.type === ConversationTypeEnum.PERSONAL ||
      Object.keys(selectedChat).length === 0
    );
  }, [selectedChat]);

  const chatNavbarShow =
    (deleteLeaveButtonsShow || muteButtonShow) && checkRole;

  return [chatNavbarShow, deleteLeaveButtonsShow, muteButtonShow];
};

export default useChatUtils;
